export const GET_INTEGRATIONS = 'GET_INTEGRATIONS';
export const SET_INTEGRATIONS = 'SET_INTEGRATIONS';
export const GET_INTEGRATION = 'GET_INTEGRATION';
export const SET_INTEGRATION = 'SET_INTEGRATION';
export const UPDATE_INTEGRATION_SETTINGS = 'UPDATE_INTEGRATION_SETTINGS';
export const STORE_INTEGRATION = 'STORE_INTEGRATION';
export const ADD_INTEGRATION = 'ADD_INTEGRATION';
export const SET_ORGANIZATION_OPTIONS = 'SET_ORGANIZATION_OPTIONS';
export const SET_KINDERGARTEN_OPTIONS = 'SET_KINDERGARTEN_OPTIONS';
export const STORE_INTEGRATION_CLIENT = 'STORE_INTEGRATION_CLIENT';
export const ADD_INTEGRATION_CLIENT = 'ADD_INTEGRATION_CLIENT';
export const GET_INTEGRATION_CLIENTS = 'GET_INTEGRATION_CLIENTS';
export const SET_INTEGRATION_CLIENTS = 'SET_INTEGRATION_CLIENTS';
export const DELETE_INTEGRATION_CLIENT = 'DELETE_INTEGRATION_CLIENT';
export const REMOVE_INTEGRATION_CLIENT = 'REMOVE_INTEGRATION_CLIENT';
export const UPDATE_INTEGRATION_CLIENT = 'UPDATE_INTEGRATION_CLIENT';
export const SET_INTEGRATION_CLIENT = 'SET_INTEGRATION_CLIENT';
export const GET_INTEGRATION_MODULES = 'GET_INTEGRATION_MODULES';
export const GET_INTEGRATION_MODULE_CLIENTS = 'GET_INTEGRATION_MODULE_CLIENTS';
export const GET_INTEGRATION_MODULE = 'GET_INTEGRATION_MODULE';
export const STORE_INTEGRATION_MODULE = 'STORE_INTEGRATION_MODULE';
export const STORE_INTEGRATION_MODULE_CLIENT = 'STORE_INTEGRATION_MODULE_CLIENT';
export const UPDATE_INTEGRATION_MODULE_CLIENT = 'UPDATE_INTEGRATION_MODULE_CLIENT';
export const GET_INTEGRATION_PARTNERS = 'GET_INTEGRATION_PARTNERS';
export const    SET_INTEGRATION_PARTNERS = 'SET_INTEGRATION_PARTNERS';
export const    STORE_INTEGRATION_PARTNER = 'STORE_INTEGRATION_PARTNER';
export const    ADD_INTEGRATION_PARTNER = 'ADD_INTEGRATION_PARTNER';
export const    UPDATE_INTEGRATION_PARTNER = 'UPDATE_INTEGRATION_PARTNER';
export const    SET_INTEGRATION_PARTNER = 'SET_INTEGRATION_PARTNER';
export const    DELETE_INTEGRATION_MODULE_CLIENT = 'DELETE_INTEGRATION_MODULE_CLIENT';
export const    UPDATE_INTEGRATION_MODULE = 'UPDATE_INTEGRATION_MODULE';
